import { HostSystemItemSortType } from "@tlc/ls2pac/dto/HostSystemItemSortType";
import { isHoldsSortType } from "../HostSystemItemSortControl";
import { LoaderFunctionArgs } from "react-router-dom";
import { getHoldsSortable } from "@tlc/ls2pac/components/services/Holds";
import axios from "axios";

export const holdsLoader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);
  const sortParam = url.searchParams.get("sort");
  const sort = isHoldsSortType(sortParam!)
    ? sortParam
    : HostSystemItemSortType.Status;
  const page = parseInt(url.searchParams.get("page")! || "0", 10);
  const pageSize = parseInt(url.searchParams.get("size")! || "10", 10);

  const dataPromise = getHoldsSortable(page, pageSize, sort, true)
    .then((holdsRes) => ({
      sort,
      page,
      pageSize,
      holds: holdsRes.holds,
      totalArrivedHolds: holdsRes.totalArrivedHolds,
      totalHolds: holdsRes.totalHolds,
    }))
    .catch((error) => {
      console.error("Error fetching child holds", error);
      if (axios.isAxiosError(error) && error.response?.status === 403) {
        throw new Response("Forbidden", { status: 403 });
      }
      throw error;
    });
  return { data: dataPromise, pageSize: pageSize }; // need synchronous pageSize for skeletons array in React.Suspense fallback
};
